import { Amplify } from "aws-amplify";

import dev from "./aws/amplify_outputs_dev.json";
import prod from "./aws/amplify_outputs_prod.json";
import sandbox from "./aws/amplify_outputs_sandbox.json";

const STAGE = process.env.REACT_APP_STAGE ?? "dev";
const configMap = { dev, prod, sandbox } as const;

// Enhanced Auth configuration for SMS OTP
// @ts-expect-error
const selectedConfig = configMap[STAGE];
// Configure Amplify with the selected environment configuration
Amplify.configure(selectedConfig);
